interface GoogleAnalyticsEventObj {
  name?: string;
  version?: string;
  event_category?: string;
  event_action?: string;
  event_label?: string;
  page_path?: string;
  page_location?: string;
  custom?: {
    [key: string]: any;
  };
  params?: {
    [key: string]: any;
  };
}

declare const window: Window & {
  sendEvent?: (eventObj: GoogleAnalyticsEventObj) => void;
};

export const logAddGiftRegistryItem = (source: string) =>
  typeof window.sendEvent === 'function' &&
  window.sendEvent({
    event_category: 'gift_registry',
    event_action: 'registry_add_item',
    event_label: 'source: ' + source,
  });

export const logRemoveGiftRegistryItem = (source: string) =>
  typeof window.sendEvent === 'function' &&
  window.sendEvent({
    event_category: 'gift_registry',
    event_action: 'registry_remove_item',
    event_label: 'source: ' + source,
  });
